import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { verifyMagicLink } from '@/lib/api';
import { useAuthStore } from '@/stores/auth.store';

export function VerifyPage() {
  const { t } = useTranslation();
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'pending' | 'success' | 'failure'>('pending');
  const setSession = useAuthStore((s) => s.setSession);

  useEffect(() => {
    const token = search.get('token');
    if (!token) {
      setStatus('failure');
      return;
    }
    let cancelled = false;
    void (async () => {
      try {
        const result = await verifyMagicLink(token);
        if (cancelled) return;
        setSession({
          accessToken: result.tokens.accessToken,
          refreshToken: result.tokens.refreshToken,
          user: {
            userId: result.user.id,
            tenantId: result.user.tenantId,
            email: result.user.email,
            phone: result.user.phone,
            name: result.user.fullName,
          },
        });
        setStatus('success');
        setTimeout(() => navigate('/', { replace: true }), 600);
      } catch {
        if (!cancelled) setStatus('failure');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [search, setSession, navigate]);

  return (
    <div className="min-h-screen bg-carnaf-paper flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        {status === 'pending' && <h1 className="text-xl text-carnaf-ink-muted">{t('verify.title')}</h1>}
        {status === 'success' && <h1 className="text-xl text-carnaf-teal font-semibold">{t('verify.success')}</h1>}
        {status === 'failure' && (
          <div>
            <h1 className="text-xl text-carnaf-red font-semibold mb-4">{t('verify.failure')}</h1>
            <Link to="/login" className="text-carnaf-teal underline">
              {t('verify.retry')}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
